export const questionOptions = [
    { title: 'Section (by Admin)', value: 'Add Section', icon: 'radix-icons:section' },
    { title: 'Title (by Admin)', value: 'Add Title', icon: 'pajamas:title' },
    { title: 'Description (by Admin)', value: 'Add Description', icon: 'fluent:text-description-16-filled' },
    { title: 'URL (by Admin)', value: 'Add URL', icon: 'ic:outline-link' },
    { title: 'Document (by Admin)', value: 'Add Document', icon: 'humbleicons:document' },
    { title: 'Image (by Admin)', value: 'Add Image', icon: 'ic:outline-image' },
    { title: 'Video (by Admin)', value: 'Add Video', icon: 'ri:video-line' },
    { title: 'Short text (by user)', value: 'Short Text', icon: 'pajamas:title' },
    { title: 'Email (by user)', value: 'Email', icon: 'line-md:email-plus' },
    { title: 'Phone number (by user)', value: 'Phone Number', icon: 'solar:phone-linear' },
    { title: 'Paragraph (by user)', value: 'Paragraph', icon: 'mingcute:paragraph-line' },
    { title: 'Number (by user)', value: 'Number', icon: 'f7:list-number' },
    { title: 'Checkbox (by user)', value: 'Checkbox', icon: 'radix-icons:checkbox' },
    { title: 'Dropdown (by user)', value: 'Dropdown', icon: 'material-symbols-light:dropdown-outline-rounded' },
    { title: 'Upload (by user)', value: 'Upload', icon: 'uil:upload' },
    { title: 'Date (by user)', value: 'Date', icon: 'ph:calendar' },
    { title: 'Time (by user)', value: 'Time', icon: 'ph:clock' },
    { title: 'Date and Time (by user)', value: 'DateTime', icon: 'ph:clock' },
    { title: 'Date range (by user)', value: 'Date Range', icon: 'heroicons:calendar-date-range-solid' },
    { title: 'Signature (by user)', value: 'Signature', icon: 'ph:signature' },
    { title: 'Calculation (by user)', value: 'Add Calculation', icon: 'carbon:calculation' },
    { title: 'From database (by user)', value: 'From Database', icon: 'hugeicons:database' },
    { title: 'Users (by user)', value: 'Add Users', icon: 'mdi:account-multiple-plus' },
    { title: 'Countries (by user)', value: 'Countries', icon: 'icomoon-free:earth' },
    { title: 'MyMap (by user)', value: 'Flight Plan', icon: 'mdi:map-search' },
];

export const SYSTEM_ROLES = ['Pending', 'Admin', 'User', 'Staff', 'QR-Code generator', 'QR-Code all documents verifier', 'Uza Ask AI'] as const;
